module.exports = __webpack_public_path__ + "img/section2Icon2.60677eed.svg";